import request from '@/utils/request'

export function add(data) {
  return request({
    url: '/DiseaseLocation/add',
    method: 'post',
    data
  })
}

export function edit(data) {
  return request({
    url: '/DiseaseLocation/edit',
    method: 'post',
    data
  })
}
